module.exports = __webpack_public_path__ + "static/media/in_a_week_6.d8339931.jpg";